import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import {OrderTop, OrderBanner} from './OrderUtils';
import MarketBadges from '../../../Shared/MarketBadges/MarketBadges';
import {orderCallBack, reportAnalytics} from './OrderSuccessSlice';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import Loader from '../../../Shared/Loader/Loader';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {ButtonMode, CellularModeEnum} from '../Esim/esimEnums';
import {clearPhone} from '../../../Block/SaleBlock/OTPVerifyPhone/OTPVerifyPhoneSlice';

const orderSuccess = (props) => {
  if (props.flowType == 'newCustomer') {
    props.clearPhone();
  }

  useEffect(() => {
    if (props?.saleInfo?.saleType == 'cellular') {
      if (props?.products != undefined && props?.products != null) {
        props?.products?.forEach((simType) => {
          var simType = 'SIM רגיל';
          if (simType?.isEsim === true) {
            simType = 'eSim';
          }
          props.reportAnalytics({
            eventCategory: 'sim_esim_process',
            eventAction: simType,
            eventLabel: 'סיום תהליך',
          });
        });
      }
    }
  }, []);

  if (props.flowType == 'newCustomer') {
    props.clearPhone();
  }

  async function waitForCallBack(props) {
    if (props.saleInfo.saleType == 'internet') {
      props.reportAnalytics({
        eventCategory: 'fiber_newsale_process',
        eventAction: 'click_38',
        eventLabel: 'callBack',
      });
    }
    const dataForCallBack = {
      id: props.saleInfo.personalInfo.id,
      phone: props.saleInfo.otpPhone,
      subjects: props.saleInfo.suggestionCallBackCode,
    };
    props.showAppLoader();
    await props.orderCallBack(dataForCallBack);
    props.hideAppLoader();
  }

  const btnPersonalAreaHandler = (props) => {
    switch (props.saleInfo.saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: props.saleInfo.flowType == 'existsCustomer' ? 'click_19' : 'click_35',
          eventLabel: 'לאיזור האישי',
        });
        break;
      case 'app':
        props.reportAnalytics({
          eventCategory: 'app_newsale_process',
          eventAction: 'click_45',
          eventLabel: 'לאיזור האישי',
        });
        break;
      case 'internet':
        props.reportAnalytics({
          eventCategory: 'fiber_newsale_process',
          eventAction: 'click_39',
          eventLabel: 'לאיזור האישי',
        });
        break;
    }
    EpiContext.navigateTo(Config.lobbyUrl);
  };

  const marketsUrlHandler = (marketName) => {
    if (marketName == null) return;
    switch (props.saleInfo.saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: props.saleInfo.flowType == 'existsCustomer' ? 'click_19' : 'click_35',
          eventLabel: marketName == 'google' ? 'google_play' : 'app_store',
        });

        break;
      case 'app':
        props.reportAnalytics({
          eventCategory: 'app_newsale_process',
          eventAction: 'click_45',
          eventLabel: marketName == 'google' ? 'google_play' : 'app_store',
        });
        break;
      case 'internet':
        props.reportAnalytics({
          eventCategory: 'fiber_newsale_process',
          eventAction: 'click_40',
          eventLabel: marketName == 'google' ? 'google_play' : 'app_store',
        });
        break;
    }
    if (marketName == 'google') {
      return window.open(Config.androidTvApplicationUrl, '_blank');
    } else {
      return window.open(Config.iosTvApplicationUrl, '_blank');
    }
  };

  const orderFooter = (props) => {
    return (
      <>
        {props.saleInfo?.saleType == 'cellular' ? (
          <>
            <Container className={`${isMobile ? 'slideAnimation' : ''}`}>
              <Row>
                <Col md='12' className='footer' style={{height: 'auto'}}>
                  <Row style={{justifyContent: 'center', alignItems: 'center'}}>
                    <div>
                      {props?.cellularOrderdetails?.buttonsMode == ButtonMode.INSTALL_ESIM && (
                        <div>
                          <Row>
                            <div className={'esimButton'}>
                              <BtnSubmit
                                text={'להפעלת ה-eSIM'}
                                onclick={() => {
                                  props.context.navigateTo(props?.esim?.esimUrl);
                                }}
                              />
                            </div>
                          </Row>
                        </div>
                      )}
                      {props?.cellularOrderdetails?.buttonsMode == ButtonMode.SHOW_NIUD && (
                        <div>
                          {props?.cellularOrderdetails?.isEsimNiudExistOnOrder &&
                          props?.cellularOrderdetails?.buttonsModeType == CellularModeEnum.ESIM_NIUD ? (
                            <Row>
                              <div className={'esimButton'}>
                                <BtnWhiteBlackBorderBigSize
                                  text={'קיבלתי את ה-SMS, בואו ננייד'}
                                  onclick={() => {
                                    props.context.navigateTo(props?.esim?.mobilizationActivationUrl);
                                  }}
                                />
                              </div>
                            </Row>
                          ) : null}
                          {!props?.cellularOrderdetails?.isEsimNiudExistOnOrder &&
                          props?.cellularOrderdetails?.buttonsModeType == CellularModeEnum.SIM ? (
                            <Row>
                              <BtnWhiteBlackBorderBigSize
                                text={'חזרה לעמוד הבית'}
                                onclick={() => {
                                  props.context.navigateTo(Config.staticWebSiteUrl);
                                }}
                              />
                            </Row>
                          ) : null}
                        </div>
                      )}

                      {props?.cellularOrderdetails?.buttonsMode == ButtonMode.INITSTATE && (
                        <Row>
                          <BtnWhiteBlackBorderBigSize
                            text={'חזרה לעמוד הבית'}
                            onclick={() => {
                              props.context.navigateTo(Config.staticWebSiteUrl);
                            }}
                          />
                        </Row>
                      )}
                    </div>
                  </Row>
                </Col>
              </Row>
            </Container>
          </>
        ) : (
          <>
            <Container className={`${isMobile ? 'slideAnimation' : ''}`}>
              <Row>
                <Col md='12' className='footer'>
                  <Row>
                    <Col className='footer__btn-holder' onClick={() => btnPersonalAreaHandler(props)}>
                      <Image src={require('./images/personal-area.svg')} alt='איזור אישי' />
                      <span className='footer__btn__label'>לאיזור האישי</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </>
        )}
      </>
    );
  };

  return (
    <Container style={props?.saleInfo?.saleType == 'cellular' ? {padding: 0} : {}} className={`orderSuccess `}>
      <OrderTop saleInfo={props.saleInfo} esim={props.esim} cellularOrderdetails={props.cellularOrderdetails} />
      <Row>
        <Col>
          {props.saleInfo.isShowSuggestionAtEnd ? (
            <OrderBanner
              click={() => waitForCallBack(props)}
              btnText={props.saleInfo.suggestionButtonText}
              title={props.saleInfo.suggestionTitle}
              successText={props.saleInfo.SuggestionSuccessText}
              isCallBackSuccess={props.success}
              isCallBackError={props.isCallBackError}
            />
          ) : null}
        </Col>
        <Loader overlay={true} />
      </Row>
      <Row>
        <Col>{props.saleInfo.isShowAppDownloadLinks ? <MarketBadges markets={marketsUrlHandler} /> : null}</Col>
      </Row>
      <Row>
        <Col className='order-footer'>{orderFooter(props)}</Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    success: state.orderSuccess.success,
    isCallBackError: state.orderSuccess.isCallBackError,
    flowType: state.saleBlock.flowType,
    cellularOrderdetails: state.saleBlock.cellularOrderdetails,
  };
};

const mapDispatchToProps = {orderCallBack, reportAnalytics, showAppLoader, hideAppLoader, clearPhone};

export default connect(mapStateToProps, mapDispatchToProps)(orderSuccess);
